export default function Error({
	path,
	loginRedirect,
	url = new URL(window.location.href),
}) {
	const returnPath = encodeURIComponent(url.pathname + url.search);
	if (loginRedirect === true) {
		const url_string = window.location.href;
		const url = new URL(url_string);
		const returnPath = encodeURIComponent(url.pathname + url.search);
		window.location.replace(`${path}/default.aspx?ReturnUrl=${returnPath}`);
		return;
	}
	return (
		<div className='tw-fixed tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center'>
			<div className='tw-bg-white tw-rounded-lg tw-border-[1px] tw-border-gray-400 tw-p-5 tw-m-6'>
				<h1 className='tw-text-red-700 tw-mb-2 tw-text-lg sm:tw-text-3xl'>
					Error: Content could not be rendered
				</h1>
				<p className='tw-my-2'>
					Please ensure that you are logged in to the system and have the
					correct permissions. Click
					<a
						href={`${path}/default.aspx?ReturnUrl=${returnPath}`}
						className='tw-mx-1 tw-text-blue-700 hover:tw-underline'>
						here
					</a>
					to login.
				</p>
				<p className='tw-my-2'>
					If you are already logged in and have the appropriate permissions,
					check that the URL is correct.
				</p>
			</div>
		</div>
	);
}
